var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankCardDefaultIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1122 1122",
    style: {
      enableBackground: "new 0 0 1122 1122"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Object"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bfbdbd"
    },
    d: "M909.663,382.803c-0.015-17.321-14.055-31.339-31.377-31.324l-634.954,0.603 c-17.307,0.019-31.354,14.063-31.332,31.381l0.337,355.735c0.015,17.311,14.078,31.336,31.377,31.324l634.962-0.595 c17.337-0.022,31.347-14.082,31.324-31.388l-0.217-226.903l-697.671,0.663l-0.074-95.998l697.67-0.66L909.663,382.803z  M553.508,546.878l0.045,41.139l-299.201,0.285l-0.045-41.142L553.508,546.878z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8C0CF0"
    },
    points: "909.708,415.64 212.038,416.3 212.112,512.298 909.783,511.635 909.783,511.635 909.738,485.339 909.708,415.648  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.33,
    y: 547.018,
    style: {
      fill: "#7000C7"
    },
    width: 299.201,
    height: 41.141
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCardDefaultIcon);
export default __webpack_public_path__ + "static/media/bank_card_default_icon.a279375adbcb86ed3f98cac3e2206458.svg";
export { ForwardRef as ReactComponent };